import { Button } from '@nexelem/components';
import { FilterData } from '@nexelem/filters';
import { openCreateOrEditFilterModal } from './CreateOrEditFilterModal';
import { useCustomTranslation } from '../../../../hooks';
import { GridFiltersProps } from '@nexelem/table';
import { faBookmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type CreateOrEditButtonProps = Pick<GridFiltersProps, 'store'> & {
  readonly filters: FilterData;
  readonly disabled: boolean;
};

export const CreateOrEditFilterButton = ({ filters, disabled, store }: CreateOrEditButtonProps) => {
  const { tWrapper } = useCustomTranslation('components.filters.createOrEditModal');

  return (
    <Button
      disabled={disabled}
      StartIcon={<FontAwesomeIcon icon={faBookmark} />}
      variant="text"
      onClick={() => openCreateOrEditFilterModal({ filters, store })}
    >
      {tWrapper('new.button')}
    </Button>
  );
};
